import {Command} from 'lucide-react';
import {useTranslation} from 'react-i18next';

import {Typography} from '@/components/ui/typography';

const CommandsHint = () => {
  const {t} = useTranslation();
  const metaKey = navigator.platform.includes('Mac') ? (
    <Command size={13} />
  ) : (
    'Ctrl'
  );
  return (
    <Typography className="flex items-center justify-center gap-1 text-sm text-gray-800">
      <kbd>{metaKey}</kbd> + <kbd>k</kbd> - {t('Commands menu')}
    </Typography>
  );
};

export default CommandsHint;
